import { render, staticRenderFns } from "./company_detail.vue?vue&type=template&id=6da12ee8"
import script from "./company_detail.js?vue&type=script&lang=js&external"
export * from "./company_detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports